import Dropzone from "dropzone";
import { escapaHtml } from "./utils";
var filename = [];
jQuery(function() {
    
    $('#project-new-modal').on('shown.bs.modal', function () {
        $("#products_table").bootstrapTable('resetView')
    });

    $("table[data-model='productos']").each(function() {

        var table_id = $(this).attr('id');

        $(this).bootstrapTable({
            url: $(this).attr('data-url'),
            classes : 'table table-hover border',
            ajaxOptions: {
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'))
                }
            },
            rowStyle: function (row, index) {
                if (row['enabled'] == '0') {
                    return { classes: 'bg-red-light text-muted' };
                }

                return { classes: 'text-muted' };
            },
            theadClasses: '/*thead-light*/ text-muted border-left border-right',
            queryParams: function(params) {

                if ($("#select_project_id").val() > 0) {
                    params.project_id = $("#select_project_id").val();
                }

                return params;
            },
            loadingTemplate: '<i class="fa fa-spinner fa-spin fa-fw fa-2x"></i>',
            buttonsClass: 'secondary',
            buttons: {
                btnAdd: {
                    text: 'New Project',
                    icon: 'fa-plus',
                    event: function () {
                        //showModalNewProject('new_product');
                        window.location.href = new_product_url;
                    },
                    attributes: {
                        title: 'Crear producto'
                    }
                }
            },
            buttonsOrder: ['btnAdd', 'refresh', 'columns'],
            //showColumns: true,
            showColumnsSearch: true,
            showColumnsToggleAll: true,
            //showExport: true,
            exportDataType: 'all',
            exportOptions: {
                fileName: function () {
                   return 'Projects';
                }
            },
            exportTypes: ['json', 'xml', 'csv', 'txt', 'excel'],
            stickyHeader: true,
            showExtendedPagination: true,
            //showPaginationSwitch: true,
            showRefresh: true,
            //showFullscreen: true,
            //showToggle: true,
            sortable:true,
            pagination: true,
            search: true,
            regexSearch: true,
            uniqueId: 'id',
            columns: [/*{
                field: 'id',
                title: 'ID',
                sortable: true,
                align: 'center',
                halign: 'center',
            },*/ {
                field: 'activo',
                title: 'Activo',
                switchable: false,
                align: 'center',
                halign: 'center',
                formatter: function (value, row, index) {

                    if (row['can_update']) {

                        if (row['activo'] == '0') {
                            return '<a id="enable_project-' + row['id'] + '" class="icon-hover" data-toggle="tooltip" data-placement="bottom" title="Activar"><i class="fas fa-toggle-off text-hight text-dark mt-1"></i></a>';
                        } else {
                            return '<a id="disable_project-' + row['id'] + '" class="icon-hover" data-toggle="tooltip" data-placement="bottom" title="Desactivar"><i class="fas fa-toggle-on text-hight text-dark mt-1"></i></a>';
                        }

                    } else {
                        return '';
                    }
                },
                events: {
                    'click [id^="enable_project"]': function (e, value, row) {
                        showModalConfirmProject('enable_project', row['id']);
                    },
                    'click [id^="disable_project"]': function (e, value, row) {
                        showModalConfirmProject('disable_project', row['id']);
                    }
                }
            }, {
                field: 'name',
                title: 'Nombre',
                sortable: true,
                align: 'center',
                halign: 'center',
                formatter: function (value, row, index) {
                    var output = '<b>' + value + '</b>';

                    if (row['descripcion_corta'] !== null && row['descripcion_corta'] != '') {
                        output += '<i class="fas fa-info-circle text-muted ml-2" data-toggle="tooltip" data-placement="bottom" title="' + row['descripcion_corta'] + '"></i>';
                    }

                    if (row['activo'] == '0') {
                        output += ' <span class="text-muted">(disabled)</span>';
                    }

                    return output;
                }
            },{
                field: 'precio',
                title: 'Precio',
                sortable: true,
                align: 'center',
                halign: 'center',
                formatter: function (value, row, index) {
                    var output = '<b>' + row['precio'] + '</b>';

                    return output;
                }
            }, {
                field: 'operate',
                title: '',
                width: 20,
                switchable: false,
                align: 'center',
                halign: 'center',
                formatter: function (value, row, index) {

                    var html_buttons = '';

                    if (row['can_update']) {
                        var hh = $("#tpanel_dashboard_url").val() + '/mercados/'+mercado_id+'/productos/' + row['id'] + '/edit';
                        html_buttons += '<a href="'+hh+'" id="edit_project-' + row['id'] + '" class="icon-hover mx-1" data-toggle="tooltip" data-placement="bottom" title="Editar">'
                                            + '<i class="fas fa-pen text-dark"></i>'
                                        + '</a>  ';
                    }

                    if (row['can_delete']) {
                        html_buttons += '<a id="delete_product-' + row['id'] + '" class="icon-hover mx-1" data-toggle="tooltip" data-placement="bottom" title="Borrar">'
                                            + '<i class="fa fa-trash text-dark"></i>'
                                        + '</a>';
                    }

                    return html_buttons;
                },
                events: {
                    'click [id^="edit_project"]': function (e, value, row) {
                        showModalNewProject('edit_project', row);
                    },
                    'click [id^="delete_product"]': function (e, value, row) {
                        showModalConfirmProject('delete_product', row['id']);
                    }
                }
            }],

        });

        $(this).on('post-body.bs.table', function (e) {
            //activate tooltips
            $("[data-toggle='tooltip']").tooltip();
        });

    });

    $("#select_project_id").on('change, input', function() {
        $("table[data-model='project']").bootstrapTable('refresh');
    });

    function showModalNewProject(operation, row = '') {
        $("#operation_product-new-modal").val(operation);

        $("#projectsModal input").removeClass('is-invalid');
        $("#projectsModal select").removeClass('is-invalid');

        $("[id^='error_']").html('');


        if (operation == 'new_product') {
            $("#submit_project-new-modal").text('Asociar Producto');
            $("#activo_product-new-modal").val('0');
            $("#precio_product-new-modal").val('');
            $("#id_product-new-modal").val('');

        } else {
            $("#submit_project-new-modal").text('Actualizar Producto');

            if (row != '') {
                $("#precio_product-new-modal").val(row['precio']);
                $("#id_product-new-modal").val(row['id_product']);
                $("#activo_product-new-modal").val(row['activo']);
                $("#id_tiendaproducto-new-modal").val(row['id']);
            }
        }

        $("#project-new-modal").modal('show');
    }

    $("#submit_project-new-modal").on('click', function() {

        //refresh errors
        $(".form-control").removeClass('is-invalid');
        $("[id^='error_']").html('');

        var operation = $("#operation_product-new-modal").val();
        var tpanel_dashboard_url = $("#tpanel_dashboard_url").val();
        if (operation == 'new_product') {
            var submit = tpanel_dashboard_url + '/tiendaproductos/store';
            var type_request = 'POST';
        } else {
            var submit = tpanel_dashboard_url + '/tiendaproductos/' + $("#id_tiendaproducto-new-modal").val() + '/update';
            var type_request = 'PUT';
        }

        var formData = {
            mercado_id : $("#mercado_id").val(),
            producto_id: $("#id_product-new-modal").val(),
            precio: $("#precio_product-new-modal").val(),
        };
        console.log(formData);

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: type_request,
            url: submit,
            data: formData,
            dataType: 'json',
            success: function (data) {

                if (data.error) {

                    $.each( data.errors, function( key, value) {
                        $("#" + key + '_product-new-modal').addClass('is-invalid');
                        $("#error_" + key + '-product-new-modal').text(value);
                    });

                } else {
                    $('#products_table').bootstrapTable('refresh');
                    $("#project-new-modal").modal('hide');
                }
            },
            error: function (data) {
                console.log(data);
            }
        });
    });

    function showModalConfirmProject(operation, id) {

        $('#errors').hide();
        $('#errors').html('');

        $("#product_id_product-confirm-modal").val(id);
        $("#operation_project-confirm-modal").val(operation);

        $("[id^='note_']").hide();
        $("[id^='error_']").html('');
        $("#note_" + operation + '-confirm-modal').show();

        $("#disable_project-confirm-modal").hide();
        $("#enable_project-confirm-modal").hide();
        $("#disableftp_project-confirm-modal").hide();
        $("#enableftp_project-confirm-modal").hide();
        $("#delete_product-confirm-modal").hide();

        switch (operation) {
            case 'disable_project':
                $("#disable_project-confirm-modal").show();
                break;

            case 'enable_project':
                $("#enable_project-confirm-modal").show();
                break;

            case 'disableftp_project':
                $("#disableftp_project-confirm-modal").show();
                break;

            case 'enableftp_project':
                $("#enableftp_project-confirm-modal").show();
                break;

            case 'delete_product':
                $("#delete_product-confirm-modal").show();
                break;

            case 'edit_project':
                $("#disable_project-confirm-modal").show();
                break;
        }

        $("#project-confirm-modal").modal('show');
        $("#project_id_project-confirm-modal").val(id);
    }

    $("#disable_project-confirm-modal, #enable_project-confirm-modal, #disableftp_project-confirm-modal, #enableftp_project-confirm-modal, #delete_product-confirm-modal").on('click', function() {
        var operation = $("#operation_project-confirm-modal").val();
        var project_id = $("#project_id_project-confirm-modal").val();
        var tpanel_dashboard_url = $("#tpanel_dashboard_url").val();

        switch (operation) {
            case 'disable_project':
                var submit = tpanel_dashboard_url + '/productos/' + $("#product_id_product-confirm-modal").val() + '/disable';
                var type = 'PUT';
                break;

            case 'enable_project':
                var submit = tpanel_dashboard_url + '/productos/' + $("#product_id_product-confirm-modal").val() + '/enable';
                var type = 'PUT';
                break;

            case 'disableftp_project':
                var submit = tpanel_dashboard_url + '/tiendaproductos/' + project_id + '/disableftp';
                var type = 'PUT';
                break;

            case 'enableftp_project':
                var submit = tpanel_dashboard_url + '/tiendaproductos/' + project_id + '/enableftp';
                var type = 'PUT';
                break;

            case 'delete_product':
                var submit = tpanel_dashboard_url + '/productos/' + $("#product_id_product-confirm-modal").val() + '/delete';
                var type = 'DELETE';
                break;
        }

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: type,
            url: submit,
            dataType: 'json',
            success: function (data) {
                switch (operation) {

                    case 'enable_project':
                        if (data.error == true){
                            $('#errors').html(data.errors);
                            $('#errors').show();
                            //alert(data.error)
                        }
                        else{
                            $('#products_table').bootstrapTable('updateByUniqueId', {
                                id: project_id,
                                row: {
                                    enabled: true
                                },
                            });
                            $("#project-confirm-modal").modal('hide');
                        }
                        break;

                    case 'disable_project':

                        $('#products_table').bootstrapTable('updateByUniqueId', {
                            id: project_id,
                            row: {
                                enabled: false
                            },
                        });
                        $("#project-confirm-modal").modal('hide');
                        break;

                    case 'enableftp_project':
                        if (data.error == true){
                            $('#errors').html(data.errors);
                            $('#errors').show();
                            //alert(data.error)
                        }
                        else{
                            $('#products_table').bootstrapTable('updateByUniqueId', {
                                id: project_id,
                                row: {
                                    ftp: true
                                },
                            });
                            $("#project-confirm-modal").modal('hide');
                        }
                        break;

                    case 'disableftp_project':
                        if (data.error == true){
                            $('#errors').html(data.errors);
                            $('#errors').show();
                            //alert(data.error)
                        }
                        else{
                            $('#products_table').bootstrapTable('updateByUniqueId', {
                                id: project_id,
                                row: {
                                    ftp: false
                                },
                            });
                            $("#project-confirm-modal").modal('hide');
                        }
                        break;

                    case 'delete_product':
                        $("#project-confirm-modal").modal('hide');
                        $('#products_table').bootstrapTable('removeByUniqueId', project_id);
                        break;
                }
                $('#products_table').bootstrapTable('refresh');
            },
            error: function (data) {
                console.log(data);
            }
        });
    });

});

$("#guardar_producto_create").on('click', function() {
        //refresh errors
        $(".form-control").removeClass('is-invalid');
        //$(".text-danger").text('');
        $("[id^='error_']").html('');

        var tpanel_dashboard_url = $("#tpanel_dashboard_url").val();
        var submit = tpanel_dashboard_url + '/productos/store';
        var type_request = 'POST';
        

        var formData = {
            mercado_id : $("#mercado_id").val(),
            name: $("#name").val(),
            activo : $("#activo").val(),
            descripcion_corta: $("#descripcion_corta").val(),
            descripcion_extendida: $("#descripcion_extendida").val(),
            precio: $("#precio").val(),
            precio_medida: $("#precio_medida").val(),
            ajustable_peso: $("#ajustable_peso").val(),
            item_pesoaproximado: $("#item_pesoaproximado").val(),
            compra_cantidad: $("#compra_cantidad").val(),
            compra_medida: $("#compra_medida").val(),
            perecedero: $("#perecedero").val(),
            necesidad_frio_transporte: $("#necesidad_frio_transporte").val(),
            necesidad_frio_rider: $("#necesidad_frio_rider").val(),
            temperatura: $("#temperatura").val(),
            receta: $("#receta").val(),
            imagenes: filename.toString(),

        };

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: type_request,
            url: submit,
            data: formData,
            dataType: 'json',
            success: function (data) {
                console.log(data);
                if (data.error!=false) {
                    alert(data.errors)
                } else {
                    //show page
                    window.location.replace(url_after_store);
                }
            },
            error: function (data) {
                console.log(data);
            }
        });
    });

    window.modalProducto = (mercadoId, productoId) => {
        $.ajax({
            url: '/tienda/producto/json/modal',
            type: 'GET',
            dataType: 'json',
            data: {
                mercadoId: mercadoId,
                productoId: productoId
            },
            success: function(data) {
                // Miniatura webp de una URL de imagen (legacy jpg/png se sirve tal cual)
                const thumbDe = (url) => url.replace(/\.webp$/i, '_thumb.webp');

                // Avatar mercado
                const mercadoImg = (data.mercado.imagenes && data.mercado.imagenes !== '')
                    ? thumbDe(`/storage/uploads/${data.mercado.imagenes.split(',')[0]}`)
                    : '/images/store_no_image.jpg';

                // 1. Imagen principal
                $('#centralimage').attr('src', data.imagen);

                // 2. Miniaturas (solo si hay más de una): se muestra el thumb
                // y al pulsar se carga la imagen grande
                let $contenedor = $('#contenedor-imagenes-modal');
                $contenedor.empty();
                if (data.imagenes.length > 1) {
                    data.imagenes.forEach((img, index) => {
                        $contenedor.append(`
                            <button onclick='cambio_imagen("${img}");' type="button"
                                class="relative h-16 cursor-pointer rounded overflow-hidden border border-gray-200">
                                <img src="${thumbDe(img)}" alt="Imagen ${index + 1}" class="h-full w-full object-cover object-center">
                            </button>`);
                    });
                }

                // 3. Header: título y precio
                $('#titulo-producto-modal').text(data.producto.name);
                const medidaLabel = (data.producto.precio_medida || '').replace('€/', '').toLowerCase();
                $('#precio-producto-modal').text(
                    `Precio por ${medidaLabel}: ${parseFloat(data.producto.precio).toFixed(2).replace('.', ',')}€`
                );

                // 5. Info acordeón (cerrado al abrir nuevo producto)
                const descripcionExtendida = (data.producto.descripcion_extendida ?? '').trim();
                const descripcionCorta = (data.producto.descripcion_corta ?? '').trim();
                $('#descripcion-producto-modal').text(descripcionExtendida !== '' ? descripcionExtendida : descripcionCorta);
                let detallesHtml = '';
                if (data.producto.receta) detallesHtml += `<p>Receta: ${escapaHtml(data.producto.receta)}</p>`;
                $('#detalles-producto-modal').html(detallesHtml);
                $('#info-producto-content-modal').addClass('hidden');
                $('#chevron-info-modal').css('transform', 'rotate(0deg)');

                // 6. Formulario
                let form = $('#add_to_cart');
                form.empty();

                form.append(`<input type="hidden" name="_token" value="${$('meta[name="csrf-token"]').attr('content')}">`);
                form.append(`<input type="hidden" name="producto_id" value="${data.producto.id}">`);
                form.append(`<input type="hidden" id="precio_medida" value="${data.producto.precio_medida}">`);
                form.append(`<input type="hidden" id="precio_producto" value="${data.producto.precio}">`);
                form.append(`<input type="hidden" id="item_pesoaproximado" value="${data.producto.item_pesoaproximado}">`);
                form.append(`<input type="hidden" id="medidas" value='${JSON.stringify(data.medidas)}'>`);
                form.append(`<input type="hidden" name="preparacion" id="preparacion" value="">`);
                form.append(`<input type="hidden" id="add_product_modal" name="add_product_modal" value="1">`);

                // Cantidad
                if (Object.keys(data.medidas).length > 0) {
                    let selectOptions = '';
                    for (const medida in data.medidas) {
                        selectOptions += `<option value="${medida}">${medida}</option>`;
                    }

                    const displayTolerancia = data.producto.ajustable_peso == 1 &&
                        data.producto.tolerancia_peso != null &&
                        data.producto.tolerancia_peso > 0;

                    let pesoHtml = '';
                    if (data.producto.item_pesoaproximado && data.producto.item_pesoaproximado > 0) {
                        const pesoStr = parseFloat(data.producto.item_pesoaproximado).toFixed(2).replace('.', ',');
                        pesoHtml += `
                            <div class="mt-2 flex items-center gap-2">
                                <p class="text-sm text-gray-600">Peso aproximado/unidad: ${pesoStr}kg</p>
                            </div>
                            <p class="text-sm text-gray-600 mt-0.5">Peso final: <span id="peso_final"></span>kg</p>`;
                    }

                    let toleranciaHtml = '';
                    if (displayTolerancia) {
                        const gramos = data.producto.tolerancia_peso * 1000;
                        toleranciaHtml = `
                            <p class="text-xs text-gray-500 mt-1 flex items-center gap-1">
                                *Margen de peso: ${gramos} gramos (${data.tolerancia_precio}€)
                                <button type="button" onclick="abrirInfoMargenPeso(this);"
                                    class="inline-flex items-center justify-center w-3.5 h-3.5 rounded-full bg-gray-400 hover:bg-gray-500 text-white text-[9px] font-bold focus:outline-none flex-shrink-0">i</button>
                            </p>`;
                    }

                    form.append(`
                        <div class="mt-4">
                            <label class="block text-sm font-semibold text-gray-700 mb-1">Cantidad</label>
                            <div class="flex items-stretch h-10 rounded-lg border border-gray-300 overflow-hidden">
                                <button type="button" onclick="restarModalProducto()"
                                    class="w-8 sm:w-10 flex-shrink-0 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold text-xl border-r border-gray-300 focus:outline-none">
                                    −
                                </button>
                                <input type="text" inputmode="decimal" min="1" step="0.5"
                                    onblur="normalizarCantidadModal()" onkeydown="if (event.key === 'Enter') { event.preventDefault(); this.blur(); }"
                                    class="flex-1 min-w-0 text-center border-0 focus:ring-0 text-sm text-gray-900 p-0"
                                    name="cantidad" value="1" id="cantidad">
                                <button type="button" onclick="sumarModalProducto()"
                                    class="w-8 sm:w-10 flex-shrink-0 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold text-xl border-l border-r border-gray-300 focus:outline-none">
                                    +
                                </button>
                                <select onchange="cambiotipo();" id="tipo_cantidad" name="tipo_cantidad"
                                    class="border-0 bg-gray-100 px-1 sm:px-2 text-sm text-gray-600 focus:outline-none focus:ring-0 h-full cursor-pointer flex-shrink-0 max-w-[88px] truncate">
                                    ${selectOptions}
                                </select>
                            </div>
                            ${pesoHtml}
                            ${toleranciaHtml}
                        </div>
                    `);
                }

                // Finalizaciones
                if (data.finalizaciones.length > 0) {
                    const options = data.finalizaciones.map(f => `<option value="${f}">${f}</option>`).join('');
                    form.append(`
                        <div class="mt-4">
                            <label for="finalizacion" class="block text-sm font-semibold text-gray-700 mb-1">Finalización</label>
                            <select id="finalizacion" name="finalizacion"
                                class="block w-full rounded-lg border-gray-300 shadow-sm text-sm text-gray-700 focus:ring-0 focus:border-gray-400">
                                ${options}
                            </select>
                        </div>
                    `);
                }

                // Preparaciones
                if (data.preparaciones.length > 0) {
                    const checkboxes = data.preparaciones.map(p => `
                        <div class="flex items-center mt-1.5">
                            <input type="checkbox" value="${p}" name="preparations"
                                class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-0">
                            <label class="ml-2 text-sm text-gray-700">${p}</label>
                        </div>`).join('');
                    form.append(`
                        <div class="mt-4">
                            <span class="block text-sm font-semibold text-gray-700 mb-1">Preparación</span>
                            ${checkboxes}
                        </div>
                    `);
                }

                // Indicaciones
                form.append(`
                    <div class="mt-4">
                        <label for="indicaciones" class="block text-sm font-semibold text-gray-700 mb-1">Indicaciones</label>
                        <textarea id="indicaciones" name="indicaciones" rows="3"
                            class="block w-full rounded-lg border-gray-300 shadow-sm text-sm focus:ring-0 focus:border-gray-400"
                            placeholder="Escribe indicaciones al tendero..."></textarea>
                    </div>
                `);

                // 7. Footer: botón añadir con precio y avatar
                const precioInicial = parseFloat(data.producto.precio).toFixed(2).replace('.', ',');
                $('#modal-footer-btn-container').html(`
                    <button onclick="add_item();" type="button" id="additembutton"
                        class="w-full flex items-center justify-between px-5 py-3 rounded-full text-white font-semibold text-sm transition hover:opacity-90"
                        style="background-color:#f97316;">
                        <span>Añadir al carrito · <span id="precioajustado">${precioInicial}</span>€</span>
                    </button>
                `);

                // 8. Botón compartir del modal
                const _shareBtn = document.getElementById('modal-share-btn');
                if (_shareBtn) {
                    const _nombre = data.producto.name;
                    const _mid = data.mercado.id;
                    const _pid = data.producto.id;
                    _shareBtn.onclick = function() {
                        compartirProducto(_mid, _pid, _nombre);
                    };
                }

                // 9. Mostrar modal y calcular precios
                const _m = document.getElementById('modalAddCart');
                _m.classList.remove('closing');
                _m.style.display = 'flex';
                document.body.style.overflow = 'hidden';
                cambiotipo();
            },
            error: function(xhr, status, error) {
                console.error('Error en la petición AJAX:', error);
            }
        });
    };

    window.cerrarModalAddCart = () => {
        const modal = document.getElementById('modalAddCart');
        if (!modal) return;
        modal.classList.add('closing');
        setTimeout(function() {
            closetooltip('modalAddCart');
            modal.classList.remove('closing');
            document.body.style.overflow = '';
        }, 220);
    };

    window.toggleInfoProductoModal = () => {
        const content = document.getElementById('info-producto-content-modal');
        const chevron = document.getElementById('chevron-info-modal');
        if (content.classList.contains('hidden')) {
            content.classList.remove('hidden');
            chevron.style.transform = 'rotate(180deg)';
        } else {
            content.classList.add('hidden');
            chevron.style.transform = 'rotate(0deg)';
        }
    };
    window._do_add_item = () => {
        if ($("#modalAddCart").css("display") !== "none") {

            if ($('#cantidad').length) {
                normalizarCantidadModal();
            }

            const checkboxes = document.querySelectorAll('input[type="checkbox"]:checked');
            const valoresSeleccionados_preparaciones = Array.from(checkboxes)
                .map(checkbox => checkbox.value)
                .join(';');
           
            const inputElement = document.getElementById('preparacion');
            inputElement.value = valoresSeleccionados_preparaciones;
        
            document.getElementById('additembutton').innerHTML = 'Procesando...';
        
            let userIsAuthenticated = document.getElementById('sesion_iniciada').value;
            
        
            if (userIsAuthenticated) {
                const form = document.getElementById('add_to_cart');
                const formData = $(form).serialize();
                let userId = document.getElementById('user_id').value;

                $.ajax({
                    url: '/additem',
                    method: 'POST',
                    data: formData,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function(response) {
                        document.getElementById('additembutton').innerHTML = 'Añadido';
                        document.getElementById('mensaje-modales').style.display = 'block';   
                        document.getElementById('mensaje-notificacion-modales').innerHTML = response.message;
                        obtenerCarritonav(userId);
                    },
                    error: function(xhr, status, error) {
                        document.getElementById('additembutton').innerHTML = 'Error, intenta de nuevo';
                    }
                });
    
            } else {

                window.location.href = `/login`;
            }
        }
    }
    

    window.add_item = () => {
        if (localStorage.getItem('precioOrientativoOk') === '1') {
            window._do_add_item();
        } else {
            document.getElementById('modalPrecioOrientativo').classList.remove('hidden');
        }
    };

    window.confirmarPrecioOrientativo = () => {
        if (document.getElementById('chkNomostrarPrecioOrientativo').checked) {
            localStorage.setItem('precioOrientativoOk', '1');
        }
        document.getElementById('modalPrecioOrientativo').classList.add('hidden');
        window._do_add_item();
    };

    window.cambio_imagen = (img_url) => {
        if ($("#modalAddCart").css("display") !== "none") {
                document.getElementById("centralimage").src = img_url;
        }
    }
    
    window.toggleCheckboxList = () => {
        if ($("#modalAddCart").css("display") !== "none") {
            var checkboxList = document.getElementById('checkboxList');
            
            if (checkboxList.style.display === 'block') {
                checkboxList.style.display = 'none';
            } else {
                checkboxList.style.display = 'block';
            }
        }
    }

    window.formateaCantidadModal = (valor) => {
        const $input = $('#cantidad');
        const minimo = parseFloat($input.attr('min'));
        const paso = parseFloat($input.attr('step'));
        const admiteDecimales = (!isNaN(minimo) && !Number.isInteger(minimo)) ||
                                (!isNaN(paso) && !Number.isInteger(paso));

        if (!admiteDecimales) {
            return String(parseInt(valor));
        }
        return String(parseFloat(parseFloat(valor).toFixed(3)));
    };

    window.cambiotipo = (coso = null) => {


        if (coso != null) {
            var tipocantidad = coso;
        } else {
            var tipocantidad = $('#tipo_cantidad').val();
        }

        var inputElement = $("#cantidad");
        const medida = JSON.parse($('#medidas').val())[tipocantidad];
        inputElement.attr("step", medida['compra_cantidad']);
        inputElement.attr("min", medida['pedido_minimo']);
        inputElement.attr("minimum", medida['pedido_minimo']);

        inputElement.val(formateaCantidadModal(medida['pedido_minimo']));

        ajustarPesoFinal();
        //Ajustamos el precio
        ajusta_precio();
    }
    

       window.ajustarPesoFinal = () => {
       
        if ($("#modalAddCart").css("display") !== "none") {
            const cantidad = $('#cantidad').val()
            const tipocantidad = $('#tipo_cantidad').val()

            if ($('#item_pesoaproximado').val() === null || $('#item_pesoaproximado').val() <= 0) {
                return
            }
            if (tipocantidad === 'Unidades') {
                $('#peso_final').text((cantidad * $('#item_pesoaproximado').val()).toFixed(3).replace('.', ','))
            } else if (tipocantidad === 'Kg') {
                $('#peso_final').text(Number(cantidad).toFixed(3).replace('.', ','))
            } else {
                $('#peso_final').text((cantidad / 1000).toFixed(3).replace('.', ','))
            }
        }
    }

    window.ajusta_precio = () => {
        var precio_final = 0;
        if ($('#precio_medida').val() == '€/Kg'){
            if ($('#tipo_cantidad').val() == 'Kg') {
                precio_final = $('#cantidad').val() * $('#precio_producto').val();
            }
            if ($('#tipo_cantidad').val() == 'Unidades') {
                precio_final = $('#cantidad').val() * $('#precio_producto').val() * $('#item_pesoaproximado').val();
            }
            if ($('#tipo_cantidad').val() == 'gramos') {
                precio_final = ($('#cantidad').val() / 1000) * $('#precio_producto').val();
            }
        }else if ($('#precio_medida').val()  == '€/250g'){
            if ($('#tipo_cantidad').val() == 'Kg') {
                precio_final = $('#cantidad').val() * $('#precio_producto').val() * 4;
            }
            if ($('#tipo_cantidad').val() == 'Unidades') {
                precio_final = $('#cantidad').val() * $('#precio_producto').val() * $('#item_pesoaproximado').val() * 4;
            }
            if ($('#tipo_cantidad').val() == 'gramos') {
                precio_final = ($('#cantidad').val() / 250) * $('#precio_producto').val();
            }
        }else if ($('#precio_medida').val()  == '€/100g'){
            if ($('#tipo_cantidad').val() == 'Kg') {
                precio_final = $('#cantidad').val() * $('#precio_producto').val() * 10;
            }
            if ($('#tipo_cantidad').val() == 'Unidades') {
                precio_final = $('#cantidad').val() * $('#precio_producto').val() * $('#item_pesoaproximado').val() * 10;
            }
            if ($('#tipo_cantidad').val() == 'gramos') {
                precio_final = ($('#cantidad').val() / 100) * $('#precio_producto').val();
            }
        }else if ($('#precio_medida').val()  == '€/g'){
            if ($('#tipo_cantidad').val() == 'Kg') {
                precio_final = $('#cantidad').val() * $('#precio_producto').val() * 1000;
            }
            if ($('#tipo_cantidad').val() == 'Unidades') {
                precio_final = $('#cantidad').val() * $('#precio_producto').val() * $('#item_pesoaproximado').val() * 1000;
            }
            if ($('#tipo_cantidad').val() == 'gramos') {
                precio_final = $('#cantidad').val() * $('#precio_producto').val();
            }
        }else if ($('#precio_medida').val()  == '€/unidad'){
            if ($('#tipo_cantidad').val() == 'Unidades') {
                precio_final = $('#cantidad').val() * $('#precio_producto').val();
            }
            if ($('#tipo_cantidad').val() == 'Kg') {
                precio_final = ($('#cantidad').val() / $('#item_pesoaproximado').val()) * $('#precio_producto').val();
            }
            if ($('#tipo_cantidad').val() == 'gramos') {
                precio_final = ($('#cantidad').val() / 1000) / $('#item_pesoaproximado').val() * $('#precio_producto').val() ;
            }
        }
        
        $('#precioajustado').html(precio_final.toFixed(2).replace('.', ','));
        ajustarPesoFinal();
    }

    window.normalizarCantidadModal = () => {
        const $input = $('#cantidad');
        const minimo = parseFloat($input.attr('min'));
        const paso = parseFloat($input.attr('step'));

        let valor = parseFloat(String($input.val()).replace(',', '.'));

        if (isNaN(valor)) {
            valor = isNaN(minimo) ? 1 : minimo;
        }
        if (!isNaN(minimo) && valor < minimo) {
            valor = minimo;
        }
        if (!isNaN(paso) && paso > 0 && !isNaN(minimo)) {
            valor = minimo + Math.round((valor - minimo) / paso) * paso;
        }

        $input.val(formateaCantidadModal(valor));

        ajusta_precio();
        return false;
    };

    window.restarModalProducto = () => {

        const $input = $('#cantidad');
        const inputVal = parseFloat(String($input.val()).replace(',', '.'));
        const stepValue = parseFloat($input.attr("step"));
        const minimum = parseFloat($input.attr("min"));
    
        if (isNaN(inputVal) || isNaN(stepValue) || isNaN(minimum)) {
            console.warn("Valores inválidos:", inputVal, stepValue, minimum);
            return false;
        }
    
        let count = inputVal - stepValue;
    
        if (count < minimum) {
            count = minimum;
        }
    
        $input.val(formateaCantidadModal(count));

        $input.change();
        ajusta_precio();
        return false;
    };
    

    window.sumarModalProducto = () => {
        const $input = $('#cantidad');

        const val = parseFloat(String($input.val()).replace(',', '.'));
        const step = parseFloat($input.attr('step'));
    
        if (isNaN(val) || isNaN(step)) {
            console.warn('Valores inválidos para suma:', val, step);
            return false;
        }
    
        let resultado = val + step;

        $input.val(formateaCantidadModal(resultado));

        $input.change();       // dispara eventos ligados al input
        ajusta_precio();       // tu lógica personalizada
    
        return false;
    };

    window.cerrarModal = (id) => {
        document.getElementById(id).style.display = 'none'
    }
    

    window.obtenerCarritonav = (id) =>{
        if(id !== null){
            $.ajax({
                url: '/obtenerCarritoNav',
                type: 'GET',
                dataType: 'json',
                data: {
                    id: id,
                },
                success: function(data) {
                $('#cantidadCarritoNav').text(data.cantidad)
                }
            })
        } 
    }